// extracted by css-extract-rspack-plugin
var _1 = "GgraZBvyUA_HgpFe";
export { _1 as "label" }
